module.exports = "<a *ngIf=\"showLogo\" class=\"logo hidden-sm hidden-xs\" [routerLink]=\"'/'\"><img src=\"../assets/logo.png\" alt=\"Boise Snowriders\" height=\"160px\" /></a>\n"


//////////////////
// WEBPACK FOOTER
// /var/snowriders/app/src/app/logo.component.html
// module id = ../../../../../src/app/logo.component.html
// module chunks = main